import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../apiClient';

import './novaSati.css';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoTokenSolicitante from '../../FuncoesGerais/VerificarTokenSolicitante';
import { useTiposChamado } from '../../hooks/useTiposChamado';
import ChamadoCreatePage from './components/ChamadoCreatePage';

function NovaSatiSolicitante() {

    const history = useHistory();
    const { tipos } = useTiposChamado();

    const verificar = async () => {
        const resultado = await verificandoApp("SOLICITANTE");
        if (!resultado) {
            history.push("/");
            return;
        }
        await verificandoTokenSolicitante(history);
    };

    const [numero, setNumero] = useState('');
    const [satDesSaius, setSatDesSai] = useState('');
    const [satEmlSolus, setSatEmlSol] = useState('');
    const [sucesso, setSucesso] = useState('N');
    const [mensagem, setMensagem] = useState('');
    const [satTip, setSatTip] = useState('');
    const [satAreSol, setSatAreSol] = useState('');
    const [codSis, setCodSis] = useState("0");
    const [codEqp, setCodEqp] = useState("0");
    const [listSistemas, setListSistemas] = useState([]);
    const [listaEquipamento, setListaEquipamento] = useState([]);
    const [imagemAbertura, setImagemAbertura] = useState(null);
    const [nomeImagemAbertura, setNomeImagemAbertura] = useState("");
    const [salvando, setSalvando] = useState(false);
    const [sugestaoIA, setSugestaoIA] = useState('');
    const [sugestaoIALoading, setSugestaoIALoading] = useState(false);
    const [sugestaoIAMensagem, setSugestaoIAMensagem] = useState('');
    const [chamadosRelacionados, setChamadosRelacionados] = useState([]);
    const [, setSugestaoTipoLoading] = useState(false);
    const [, setTituloSugerido] = useState('');
    const [, setTituloLoading] = useState(false);
    const [, setUrgenciaInfo] = useState({ urgente: false, insatisfeito: false, mensagem: '' });
    const [, setUrgenciaLoading] = useState(false);

    const retornaNumero = async () => {
        try {
            const response = await api.post('/api/conProximaSati', {});
            setNumero(Array.isArray(response.data) && response.data.length > 0 ? response.data[0].PROX : '');
        } catch (error) {
            console.error('Erro ao buscar próxima SATI:', error);
        }
    };

    const pegarSistemas = async (e) => {

        let listaSistemas = [];

        try {
            const response = await api.post('/api/getSistemas', {});
            let i = 0;
            while (i < response.data.length) {
                listaSistemas.push({
                    codsis: response.data[i].codsis,
                    nomsis: response.data[i].nomsis
                })
                i++;
            }
            setListSistemas(listaSistemas);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const pegarEquipamento = async (codUsu) => {

        let listaEqp = [];

        try {
            const response = await api.post('/api/getHardwares', { codUsu });
            let i = 0;

            while (i < response.data.length) {
                listaEqp.push({
                    codhar: response.data[i].CODEQP,
                    nomeqp: response.data[i].NOMEQP,
                    sereqp: response.data[i].SEREQP,
                    pateqp: response.data[i].PATEQP
                })
                i++;
            }
            setListaEquipamento(listaEqp);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    useEffect(() => {
        verificar();
        retornaNumero();
        pegarSistemas();
        pegarEquipamento(localStorage.getItem('codUsu'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const buscarSugestaoIA = async () => {
        const desc = (satDesSaius || '').trim();
        if (desc.length < 3) {
            setSugestaoIAMensagem('Digite ao menos 3 caracteres na descrição para buscar sugestões.');
            setSugestaoIA('');
            setChamadosRelacionados([]);
            return;
        }
        setSugestaoIAMensagem('');
        setSugestaoIALoading(true);
        setSugestaoIA('');
        setChamadosRelacionados([]);
        try {
            const response = await api.post('/api/sugestao-abertura', { descricao: desc });
            setSugestaoIA(response.data?.sugestao ?? '');
            setChamadosRelacionados(Array.isArray(response.data?.chamadosRelacionados) ? response.data.chamadosRelacionados : []);
            if (response.data?.mensagem) setSugestaoIAMensagem(response.data.mensagem);
        } catch (err) {
            console.error('Erro ao buscar sugestão IA:', err);
            setSugestaoIA('');
            setSugestaoIAMensagem(err.response?.data?.error || 'Erro ao buscar sugestão. Tente novamente.');
        } finally {
            setSugestaoIALoading(false);
        }
    };

    // eslint-disable-next-line no-unused-vars -- reservado para uso futuro
    const _buscarSugestaoTipo = async () => {
        const desc = (satDesSaius || '').trim();
        if (desc.length < 3 || !tipos || tipos.length === 0) {
            return;
        }
        setSugestaoTipoLoading(true);
        try {
            const response = await api.post('/api/sugestao-tipo', { descricao: desc, tipos: tipos.map((t) => ({ id: t.id, nome: t.nome })) });
            const sugeridos = response.data?.tiposSugeridos || [];
            if (sugeridos.length > 0 && sugeridos[0].id) setSatTip(String(sugeridos[0].id));
        } catch (err) {
            console.error('Erro ao sugerir tipo:', err);
        } finally {
            setSugestaoTipoLoading(false);
        }
    };

    // eslint-disable-next-line no-unused-vars -- reservado para uso futuro
    const _buscarTitulo = async () => {
        const desc = (satDesSaius || '').trim();
        if (desc.length < 3) return;
        setTituloLoading(true);
        setTituloSugerido('');
        try {
            const response = await api.post('/api/sugestao-titulo', { descricao: desc });
            setTituloSugerido(response.data?.titulo || '');
        } catch (err) {
            console.error('Erro ao gerar título:', err);
        } finally {
            setTituloLoading(false);
        }
    };

    // eslint-disable-next-line no-unused-vars -- reservado para uso futuro
    const _detectarUrgencia = async () => {
        const texto = (satDesSaius || '').trim();
        if (texto.length < 5) return;
        setUrgenciaLoading(true);
        setUrgenciaInfo({ urgente: false, insatisfeito: false, mensagem: '' });
        try {
            const response = await api.post('/api/detectar-urgencia', { texto });
            setUrgenciaInfo({
                urgente: !!response.data?.urgente,
                insatisfeito: !!response.data?.insatisfeito,
                mensagem: response.data?.mensagem || ''
            });
        } catch (err) {
            console.error('Erro ao detectar urgência:', err);
        } finally {
            setUrgenciaLoading(false);
        }
    };

    const handleSubmit = async (e) => {

        let erro = 'OK';

        if (satAreSol !== "I" && satAreSol !== "S") {
            setMensagem("Selecionar o setor!");
            erro = 'S';
        }

        if (satDesSaius.trim().length === 0) {
            setMensagem("Preencher descrição!");
            erro = 'S';
        }

        if (!satTip || String(satTip).trim() === '') {
            setMensagem("Selecione o tipo do chamado!");
            erro = 'S';
        }

        e.preventDefault();

        if (erro === 'S') {
            setMensagem('Verifique os campos antes de salvar.');
            return;
        }

        const codUsu = localStorage.getItem('codUsu');
        if (!codUsu || codUsu === '0' || String(codUsu).trim() === '') {
            setMensagem('Sessão inválida. Faça login novamente como Solicitante.');
            return;
        }

        let satAte = 1;
        let satDesSai = satDesSaius;
        const usrEml = localStorage.getItem('usrEmlSat');
        const satEmlSol = (usrEml != null && usrEml !== '' ? usrEml : '') + (satEmlSolus && satEmlSolus.trim() ? ';' + satEmlSolus.trim() : '');

        const codUsuNum = Number(codUsu);
        const satTipNum = satTip !== '' && satTip != null ? Number(satTip) : null;
        const codSisVal = (codSis === '0' || codSis === '' || codSis == null) ? null : (Number(codSis) || codSis);
        const codEqpVal = (codEqp === '0' || codEqp === '' || codEqp == null) ? null : (Number(codEqp) || codEqp);

        const body = {
            satDesSai,
            codUsu: !Number.isNaN(codUsuNum) ? codUsuNum : codUsu,
            satEmlSol: satEmlSol || '',
            satAte,
            satTip: satTipNum != null && !Number.isNaN(satTipNum) ? satTipNum : satTip,
            satAreSol: satAreSol || ''
        };
        if (codSisVal != null) body.codSis = codSisVal;
        if (codEqpVal != null) body.codEqp = codEqpVal;

        setSalvando(true);
        setMensagem('');
        try {
            const response = await api.post('/api/inserirSATI', body);

            if (response.data && response.data.message === 'Erro ao inserir dados') {
                const errDetail = response.data.error?.message || response.data.error?.sqlMessage || (response.data.error && String(response.data.error));
                setMensagem(errDetail ? `Erro ao gravar chamado: ${errDetail}` : 'Erro ao gravar chamado. Tente novamente.');
                setSucesso('N');
                return;
            }

            const rawNum = response.data?.numero ?? response.data?.satNum ?? response.data?.PROX ?? numero;
            const numeroCriado = rawNum != null && rawNum !== '' ? Number(rawNum) : Number(numero);
            const satNumValido = Number.isFinite(numeroCriado) && numeroCriado > 0;

            if (satNumValido && imagemAbertura && nomeImagemAbertura) {
                try {
                    await api.post('/api/inserirAnexo', {
                        satNum: numeroCriado,
                        nomArq: nomeImagemAbertura,
                        Arquivo64: imagemAbertura
                    });
                } catch (errImg) {
                    console.error('Anexo de imagem na abertura:', errImg);
                    setMensagem('Chamado criado, mas o anexo não foi gravado. Tente anexar depois na tela do chamado.');
                }
            }

            if (codEqp !== '0') {
                try {
                    await api.post('/api/historicoHardware', {
                        codHar: codEqp, desHis: `Abertura de chamado - ${numeroCriado} \n\nPara tratamento do hardware.`
                    });
                } catch (errHw) {
                    console.error('Erro ao registrar histórico de hardware:', errHw);
                }
            }

            setMensagem('');
            setSucesso('S');
        } catch (error) {
            console.error('Erro ao inserir dados:', error);
            const msgBackend = error.response?.data?.message || error.response?.data?.error;
            setMensagem(msgBackend ? `Erro ao inserir dados: ${msgBackend}` : 'Erro ao inserir dados. Tente novamente.');
            setSucesso('N');
        } finally {
            setSalvando(false);
        }
    };

    const nomeUsuario = localStorage.getItem('nomUsuSat') || '';

    const handleAnexoChange = ({ base64, nome }) => {
        setImagemAbertura(base64);
        setNomeImagemAbertura(nome || '');
    };

    return (
        <ChamadoCreatePage
            descricao={satDesSaius}
            setDescricao={setSatDesSai}
            tipo={satTip}
            setTipo={setSatTip}
            setor={satAreSol}
            setSetor={setSatAreSol}
            codSis={codSis}
            setCodSis={setCodSis}
            codEqp={codEqp}
            setCodEqp={setCodEqp}
            listSistemas={listSistemas}
            listaEquipamento={listaEquipamento}
            tipos={tipos}
            nomeUsuario={nomeUsuario}
            emailAdicional={satEmlSolus}
            setEmailAdicional={setSatEmlSol}
            nomeAnexo={nomeImagemAbertura}
            onAnexoChange={handleAnexoChange}
            onSubmit={handleSubmit}
            salvando={salvando}
            mensagem={mensagem}
            sucesso={sucesso}
            sugestaoIA={sugestaoIA}
            sugestaoIALoading={sugestaoIALoading}
            sugestaoIAMensagem={sugestaoIAMensagem}
            chamadosRelacionados={chamadosRelacionados}
            onBuscarSugestaoIA={localStorage.getItem('ia_habilitada') !== '0' ? buscarSugestaoIA : undefined}
        />
    );
}

export default NovaSatiSolicitante;
